<template>
  <section>
    <v-card>
      <v-card-text>
        <!-- <v-autocomplete
          :items="l_unidades"
          :item-value="
            v => {
              return v.nombre_unidad;
            }
          "
          item-text="nombre_unidad"
          v-model="filter.nombre_unidad"
          label="Tipo de activo"
          clearable
          @change="filtrarUnidades()"
        /> -->
        <v-flex xs12>
          <transition name="slide-fade">
            <div class="filter-container" v-show="filterShow">
              <v-icon small color="primary">search</v-icon>
              <div class="filter-item">
                <v-text-field
                  class="text-field-reducido"
                  label="CI"
                  type="text"
                  v-model="filter_persona.nro_doc"
                  clearable
                  @input="filtrarPersonas()"
                ></v-text-field>
              </div>
              <!--          <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Ap paterno"
                      type="text"
                      v-model="filter.ap_paterno"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Ap materno"
                      type="text"
                      v-model="filter.ap_materno"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Nombres"
                      type="text"
                      v-model="filter.nombres"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Nro item"
                      type="text"
                      v-model="filter.nro_item"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Cargo"
                      type="text"
                      v-model="filter.cargo"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Puesto"
                      type="text"
                      v-model="filter.puesto"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div> -->
              <div class="filter-item">
                <v-text-field
                  class="text-field-reducido"
                  label="Unidad"
                  type="text"
                  v-model="filter.nombre_unidad"
                  clearable
                  @input="filtrarUnidades()"
                ></v-text-field>
              </div>

              <!-- botones cerrar -->
              <div class="btn-filter">
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="closeFilterSlide()"
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                  <span>Cerrar filtros</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </v-flex>
      </v-card-text>
      <!-- {{ panel }} -->
      <v-card-text class="py-0">
        <v-expansion-panel popout v-model="panel">
          <v-expansion-panel-content
            v-for="unidad in l_unidades"
            :key="unidad.id"
            lazy
          >
            <template v-slot:header>
              <div>
                <v-avatar
                  :color="foto ? '#FFF' : 'light-blue darken-2'"
                  size="40"
                  class="mr-2"
                >
                  <span class="white--text font-weight-bold caption">{{
                    unidad.sigla || "-"
                  }}</span> </v-avatar
                >{{ unidad.nombre_unidad }}
              </div>
            </template>
            <v-card>
              <v-card-text class="pa-0">
                <EstructuraUnidad
                  :id_unidad="parseInt(unidad.id)"
                  :filtros_persona="filter_persona"
                />
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import EstructuraUnidad from "./EstructuraUnidad.vue";
export default {
  // Variables iniciales
  props: ["filtros"],
  components: { EstructuraUnidad },
  data() {
    return {
      l_unidades: [],
      l_copia_unidades: [],
      filter: {},
      filter_persona: {},
      filterShow: true,
      panel: []
    };
  },
  computed: {},
  async created() {
    // Cargamos unidades
    await this.cargarUnidades(this.filtros);
  },
  mounted() {},
  methods: {
    // MEtodo pra cargar unidades
    async cargarUnidades(filtros = {}) {
      let l_tmp = await this.$query.select(
        "v_unidades_generales",
        filtros ,
        ["nombre_unidad", "sigla", "id:id_unidad"]
      );
      // Ordenamos la lista
      this.l_unidades = l_tmp.sort((a, b) =>
        a.nombre_unidad.localeCompare(b.nombre_unidad)
      );
      this.l_copia_unidades = JSON.parse(JSON.stringify(this.l_unidades));
    },
    // Metodo para filtrar unidades
    async filtrarUnidades() {
      // Recorremos los filtros del slide
      let obj_filters = {};
      for (const key in this.filter) {
        if (this.filter[key]) {
          obj_filters[key] = this.filter[key];
        } else {
          delete obj_filters[key];
        }
      }
      // Cargamos unidades
      await this.cargarUnidades(obj_filters);
    },
    async filtrarPersonas() {
      // Recorremos los filtros del slide
      let obj_filters = {};
      for (const key in this.filter_persona) {
        if (this.filter_persona[key]) {
          obj_filters[key] = this.filter_persona[key];
        } else {
          delete obj_filters[key];
        }
      }
      let l_personas = await this.$query.select(
        "v_lista_personal_activo",
        obj_filters,
        ["id_persona", "id_unidad"]
      );
      // Cargamos unidades
      let filtro_unidad = {
        // lista_id_unidades:l_personas.map(ele => ele.id_unidad)
        lista_id_unidades: l_personas.map(ele => ele.id_unidad)
      };
      console.log("🚀 ~ filtrarPersonas ~ filtro_unidad:", filtro_unidad);

      await this.cargarUnidades(filtro_unidad);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-expansion-panel__container--active {
  background: rgb(0, 84, 133) !important;
  color: white !important;
}
.v-expansion-panel__container {
  &:hover {
    background: rgba(57, 210, 248, 0.288);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reportes_lista_personal/components/EstructuraOrganizacional.vue